// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideWebhook as RawLucideWebhook } from "lucide-react";
export const LucideWebhook = /* @__PURE__ */ createIcon(RawLucideWebhook, "LucideWebhook", 2);
